import { useEffect, useState } from 'react';
import { timeLeft } from '../../lib/format';

// Explicit lookup tables replace nested ternaries — easier to read and to test.
const DIGIT_CLASSES = {
  lg: 'font-mono text-4xl md:text-5xl leading-none tabular-nums',
  sm: 'font-mono text-xl leading-none tabular-nums',
  md: 'font-mono text-3xl leading-none tabular-nums',
};

const BOX_CLASSES = {
  lg: 'p-3 md:p-4',
  sm: 'p-2',
  md: 'p-2 md:p-3',
};

const CELL_DEFS = [
  { key: 'd', field: 'days', label: 'Days' },
  { key: 'h', field: 'hours', label: 'Hrs' },
  { key: 'm', field: 'minutes', label: 'Min' },
  { key: 's', field: 'seconds', label: 'Sec' },
];

export const CountdownTimer = ({
  isoDate,
  size = 'md',
  showLabels = true,
  dataTestidPrefix = 'countdown',
}) => {
  const [t, setT] = useState(() => timeLeft(isoDate));
  useEffect(() => {
    const id = setInterval(() => setT(timeLeft(isoDate)), 1000);
    return () => clearInterval(id);
  }, [isoDate]);

  const digitClass = DIGIT_CLASSES[size] || DIGIT_CLASSES.md;
  const boxClass = BOX_CLASSES[size] || BOX_CLASSES.md;
  const color = t.urgent
    ? 'text-[color:var(--pd-accent-orange)]'
    : 'text-[color:var(--pd-text)]';

  return (
    <div className="grid grid-cols-4 gap-2" data-testid={dataTestidPrefix} aria-live="polite">
      {CELL_DEFS.map((cell) => (
        <div
          key={cell.key}
          className={`bg-[color:var(--pd-bg)] border border-[color:var(--pd-text)]/25 rounded-lg text-center ${boxClass}`}
          data-testid={`${dataTestidPrefix}-${cell.key}`}
        >
          <div className={`${digitClass} ${color}`}>{String(t[cell.field]).padStart(2, '0')}</div>
          {showLabels && (
            <div className="font-mono text-[10px] text-muted-sage mt-1 uppercase tracking-widest">{cell.label}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CountdownTimer;
